// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__12qVU","log":"ModalInventoryLogs_log__2N7Un","date":"ModalInventoryLogs_date__2ddR5","userName":"ModalInventoryLogs_userName__iL-G3"};